import { ReactNode } from 'react';
import { SharedProviders } from 'shared';
import { api } from '@/services/api.config';

// The single shared provider the host mounts. Only the api instance is host-injected; toasts, alert
// dialogs and dialogs are shared's own UI, so nothing is passed for them.
export default function SharedServicesProvider({ children }: { children: ReactNode }) {
  return <SharedProviders api={api}>{children}</SharedProviders>;
}
